import { combineReducers } from "redux";

import { toursReducer } from "./tourReducer";

const reducers = combineReducers({
    tours: toursReducer
})

export default reducers;